// import React, { useState, useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import "../pages/Services.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSadTear } from "@fortawesome/free-solid-svg-icons";

// const services = [
//   {
//     title: "Chemistry - Chemical Kinetics, HydroCarbon & G-14",
//     pdfUrl:
//       "https://drive.google.com/file/d/1TX4tI9HY9Upgk0W7D22UmoODbhZS2mjU/preview",
//   },
//   {
//     title: "Physics - Electrostatics, Sound Wave",
//     pdfUrl:
//       "https://drive.google.com/file/d/1jNxmnqV5FPx7c9jNk5vlAJefpqoDQ3aw/preview",
//   },
//   {
//     title: "Chemistry - Chemical Kinetics, HydroCarbon & G-14",
//     pdfUrl:
//       "https://drive.google.com/file/d/1mlcW0AG3hSaYAL0yEDuoYwbsT-fjegDc/preview",
//   },
//   {
//     title: "Maths - Relation & Function, Complex no., ITF, Determinant",
//     pdfUrl:
//       "https://drive.google.com/file/d/1qs6vZkrggkSbICHVTA9pioi-4zn-8xcM/preview",
//   },

//   // Add more services as needed
// ];

// const QnA = () => {
//   const [expandedPdf, setExpandedPdf] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     AOS.init({
//       duration: 1000,
//       easing: "ease-in-out",
//       once: true,
//     });
//   }, []);

//   const expandPdf = (pdfUrl) => {
//     setExpandedPdf(pdfUrl);
//   };

//   const closePdf = () => {
//     setExpandedPdf(null);
//   };

//   const handleSearch = (e) => {
//     setSearchTerm(e.target.value);
//   };

//   const filteredServices = services.filter((service) =>
//     service.title.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <>
//       <section className="qna-container">
//         <h1 className="service-title hero" data-aos="fade-up">
//           Question & Answer
//         </h1>
//         <div className="search-bar" data-aos="fade-up">
//           <input
//             type="text"
//             placeholder="Search anything..."
//             value={searchTerm}
//             onChange={handleSearch}
//           />
//         </div>
//         <div className="services">
//           {filteredServices.length > 0 ? (
//             filteredServices.map((service, index) => (
//               <div className="service" key={index}>
//                 <h2 className="service-title">{service.title}</h2>
//                 <div className="pdf-container">
//                   <iframe
//                     src={service.pdfUrl}
//                     className={`pdf-viewer ${
//                       expandedPdf === service.pdfUrl ? "expanded" : ""
//                     }`}
//                     title={service.title}
//                     onClick={() => expandPdf(service.pdfUrl)}
//                   ></iframe>
//                   {expandedPdf === service.pdfUrl && (
//                     <div className="close-btn" onClick={closePdf}>
//                       Close PDF
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="coming-soon" data-aos="fade-up">
//               <FontAwesomeIcon icon={faSadTear} size="3x" />
//               <p>Available Soon</p>
//             </div>
//           )}
//         </div>
//       </section>
//     </>
//   );
// };

// export default QnA;

import React from "react";
import "./OnlineTest.css";

const Qna = () => {
  return (
    <div className="online-test-container">
      <iframe
        src="https://pdf-virid.vercel.app/qna"
        frameBorder="0"
        title="Online Test Platform"
        allow="fullscreen"
      ></iframe>
    </div>
  );
};

export default Qna;
